<template lang="pug">
  div.margin-top-5
    el-row
      el-col(:span="1") &nbsp;
      el-col(:span="22")
        custom-checkbox.margin-top-10(v-model="graph.labels.isActive") Axis labels
        labels-form(
          v-show="graph.labels.isActive"
          :param="graph.labels"
          ref="coding-graph-labels"
        )
    el-row
      el-col(:span="1") &nbsp;
      el-col(:span="22")
        custom-checkbox.margin-top-10(v-model="graph.legends.isActive") Legends
        criteria-list-form(
          v-show="graph.legends.isActive"
          :item-list="graph.legends.legs"
          value-attr="value"
          value-placeholder="Legend's name"
          ref="coding-graph-legends"
        )
    el-row
      el-col(:span="1") &nbsp;
      el-col(:span="22")
        custom-checkbox.margin-top-10(v-model="graph.limit.isActive") Axis limits
        limit-form(
          v-show="graph.limit.isActive"
          :param="graph.limit"
          ref="coding-graph-limits"
        )
    el-row
      el-col(:span="1") &nbsp;
      el-col(:span="22")
        custom-checkbox.margin-top-10(v-model="graph.scale.isActive") Axis scales
        scale-form(
          v-show="graph.scale.isActive"
          :param="graph.scale"
          ref="coding-graph-scales"
        )
    el-row
      el-col(:span="1") &nbsp;
      el-col(:span="22")
        custom-checkbox.margin-top-10(v-model="graph.line.isActive") Lines
        line-form(
          v-show="graph.line.isActive"
          :lines="graph.line.lines"
          ref="coding-graph-lines"
        )
</template>

<script>
  import CustomCheckbox from '@/components/instructor/Question/Components/CustomCheckbox'
  import CriteriaListForm from './CriteriaListForm.vue'
  import LabelsForm from './GraphElements/LabelsForm.vue'
  import LineForm from './GraphElements/LineForm.vue'
  import LimitForm from './GraphElements/LimitForm.vue'
  import ScaleForm from './GraphElements/ScaleForm.vue'

  export default {
    components: {
      CustomCheckbox,
      CriteriaListForm,
      LabelsForm,
      LineForm,
      LimitForm,
      ScaleForm,
    },

    props: {
      graph: {
        type: Object,
        required: true,
      },
    },

    methods: {
      validateAll() {
         let isValid = true
        if (this.graph.labels.isActive) {
          isValid &= this.$refs['coding-graph-labels'].validateAll()
        }
        if (this.graph.legends.isActive) {
          isValid &= this.$refs['coding-graph-legends'].validateAll()
        }
        if (this.graph.line.isActive) {
          isValid &= this.$refs['coding-graph-lines'].validateAll()
        }
        if (this.graph.limit.isActive) {
          isValid &= this.$refs['coding-graph-limits'].validateAll()
        }
        if (this.graph.scale.isActive) {
          isValid &= this.$refs['coding-graph-scales'].validateAll()
        }

        return isValid
      },
    },
  }
</script>